function shopliftTest() {
  let hypothesisID = "1ff3429e-1018-4403-b9ab-2c070e6d4861"; //the shopplift test ID
  window.shoplift.isHypothesisActive(hypothesisID).then((active) => {
    console.log("SHOPLIFT:: checking hypothesis status");

    if (active) {
      console.log("SHOPLIFT:: hypothesis ACTIVE");

      const testStyle = document.createElement("style");
      const cssRule =
        ".ProductItem__Info { flex-flow: column-reverse nowrap !important; }";

      testStyle.appendChild(document.createTextNode(cssRule));

      document.head.appendChild(testStyle);
    }
  });
}

shopliftTest();